import React from 'react'
import cn from 'classnames'
import { AiOutlineLoading } from 'react-icons/ai'

const Spinner = ({ className = '', ...rest }) => (
  <AiOutlineLoading className={cn('animation-spin', className)} />
)

export default Spinner
